



































































import {Component, Prop} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import Loading from "@/components/Loading.vue";
import CustomSectionHeader from "@/components/CustomSectionHeader.vue";
import MetaItem from "@/components/device/meta/MetaItem.vue";
import MetaSection from "@/components/device/meta/MetaSection.vue";
import {BaseStation, Device} from "@/types/core";
import {HttpResponse} from "@/types/http";
import {CoreClient, curCoreClient} from "@/services/CoreClient";

@Component({
  components:{
    VueError,
    Loading,
    CustomSectionHeader,
    MetaItem,
    MetaSection
  }
})
export default class BaseStationMetaSection extends MetaSection {
  @Prop({ default: () => {},  type: Object}) baseStation!:BaseStation;

  private coreClient:CoreClient = curCoreClient;

  protected getMeta(): Record<string, string | number | boolean | string[] | number[]> {
    return this.baseStation.customMeta;
  }

  protected async saveMeta(newMeta: Record<string, string | number | boolean | string[] | number[]>): Promise<HttpResponse> {
    const reply = await this.coreClient.updateBaseStationMetadata({
      lrrId: this.baseStation.lrrId,
      customMeta: newMeta
    });

    if(!reply.errorMsg) {
      // we update the local copy
      this.baseStation.customMeta = newMeta;
    }

    return reply;
  }
}
